module.exports = __webpack_public_path__ + "ar.svg?d1146d1684e28fe8c3554a51a92be727";